import { render, staticRenderFns } from "./EditJenisBarang.vue?vue&type=template&id=a33dedb2&"
import script from "./EditJenisBarang.vue?vue&type=script&lang=js&"
export * from "./EditJenisBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports